import React from 'react'
import { Box, IconButton, Modal } from '@mui/material'
import MusicNote from '@mui/icons-material/MusicNote'
import StylesCard from '../discover/elements/StylesCard'
import { useDispatch, useSelector } from 'react-redux'
import { selectStylePopup, setShowStyle } from '../../actions/mainSlice'


interface StylesDialogProps {
    discoverData: any
}

const StylesDialog = ({discoverData}: StylesDialogProps) => {
    const dispatch = useDispatch()
    const open = useSelector(selectStylePopup)

    const handleModal = (open: boolean) => {
        dispatch(setShowStyle({showStyle: open}))
    }

    return (
        <>
            <IconButton sx={{backgroundColor: '#fff!important'}} onClick={() => handleModal(!open)}>
                <MusicNote color='primary'/>
            </IconButton>
            <Modal
				open={open && discoverData !== null}
				onClose={() => handleModal(false)}
				aria-labelledby="modal-search"
				aria-describedby="modal-search-results"
				sx={{}}
				>
				<Box sx={{
					background: '#00000030!important',
					borderRadius: '16px',
					position: 'absolute',
					bottom: '0px',
					left: '50%',
					transform: 'translate(-50%, 0%)',
					backdropFilter: 'blur(1.5rem)',
					width: '100%',
					bgcolor: 'background.paper',
					border: '2px solid #000',
					maxHeight: '95vh',
					transition: 'max-height 0.15s ease-out',
					boxShadow: 24,
					overflow: 'hidden',
					}}>
						<StylesCard handleClose={() => handleModal(false)}  discoverData={discoverData}/>
				</Box>
			</Modal>
        </>
    )
}

export default StylesDialog